import type { StatusBadgeTone } from "@components";
import { AlertTriangle, CheckCircle, File06 } from "@untitledui/icons";
import { AlertOctagon } from "lucide-react";
import type { ExpenseStatus } from "../types";

export const EXPENSE_STATUS_BADGE_TONES: Record<
	Exclude<ExpenseStatus, 0>,
	StatusBadgeTone
> = {
	1: "error",
	2: "warning",
	3: "success",
	4: "gray",
};

export const EXPENSE_STATUS_BADGE_ICONS: Record<
	Exclude<ExpenseStatus, 0>,
	React.ComponentType<{ className?: string }>
> = {
	1: AlertOctagon,
	2: AlertTriangle,
	3: CheckCircle,
	4: File06,
};

export const EXPENSE_STATUS_LABELS: Record<
	Exclude<ExpenseStatus, 0>,
	string
> = {
	1: "Fora do padrão",
	2: "Atenção",
	3: "Dentro do esperado",
	4: "Sem despesas",
};

export const EXPENSE_STATUS_FILTER_OPTIONS = [
	{ id: 0 as const, label: "Todos" },
	{ id: 1 as const, label: "Fora do padrão" },
	{ id: 2 as const, label: "Atenção" },
	{ id: 3 as const, label: "Dentro do esperado" },
];

export const REIMBURSEMENT_REASON_MAP: Record<number, string> = {
	1: "Combustível",
	2: "Estacionamento",
	3: "Lavagem",
	4: "Alimentação",
	5: "Hospedagem",
	6: "Outros",
};

export const REIMBURSEMENT_REASON_OPTIONS = [
	{ id: 1 as const, label: "Combustível" },
	{ id: 2 as const, label: "Estacionamento" },
	{ id: 3 as const, label: "Lavagem" },
	{ id: 4 as const, label: "Alimentação" },
	{ id: 5 as const, label: "Hospedagem" },
	{ id: 6 as const, label: "Outros" },
];
